import { profileData, statsData } from '@/mocks/home';

export default function ProfileSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            个人资料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">了解水野朝阳的基本信息与演艺历程</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-12">
          {statsData.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-accent-200/60 transition-colors duration-300"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${stat.icon} text-accent-600 text-lg`} />
              </div>
              <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">{stat.value}</p>
              <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="bg-background-100/70 border border-background-200/70 rounded-xl p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="space-y-3">
              <InfoRow label="出生日期" value={profileData.birthDate} />
              <InfoRow label="出生地" value={profileData.birthPlace} />
              <InfoRow label="身高" value={profileData.height} />
            </div>
            <div className="space-y-3">
              <InfoRow label="三围" value={profileData.measurements} />
              <InfoRow label="出道年份" value={profileData.debut} />
              <InfoRow label="经纪公司" value={profileData.agency} />
            </div>
            <div className="space-y-3">
              <p className="text-sm text-foreground-500">爱好</p>
              <div className="flex flex-wrap gap-2">
                {profileData.hobbies.map((h) => (
                  <span key={h} className="px-3 py-1 text-xs bg-secondary-100 text-secondary-700 rounded-full">{h}</span>
                ))}
              </div>
              <p className="text-sm text-foreground-500 mt-2">特长</p>
              <div className="flex flex-wrap gap-2">
                {profileData.specialties.map((s) => (
                  <span key={s} className="px-3 py-1 text-xs bg-accent-100 text-accent-700 rounded-full">{s}</span>
                ))}
              </div>
            </div>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed">{profileData.bio}</p>
        </div>
      </div>
    </section>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline gap-2">
      <span className="text-sm text-foreground-500 shrink-0">{label}</span>
      <span className="text-sm text-foreground-800 font-medium">{value}</span>
    </div>
  );
}